module.exports = __webpack_public_path__ + "img/frying-spur.df094643.jpeg";